import React from 'react';
import { componentNameForUrlPage } from "../../const";
export default function View(props) {
  var className = props.className,
    url = props.url,
    fullHeight = props.fullHeight;
  if (!url) {
    return /*#__PURE__*/React.createElement("div", null, "404");
  }
  return /*#__PURE__*/React.createElement("iframe", {
    key: url,
    className: className,
    title: url,
    src: url,
    style: {
      border: 0,
      width: '100%',
      height: fullHeight ? '100%' : undefined
    }
  });
}
View.displayName = componentNameForUrlPage;